import React from 'react';
import { createPortal } from 'react-dom';
import { Backdrop, Panel } from './styles';

interface AiManagementDrawerProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  variant?: 'main' | 'side';
  shifted?: boolean;
  bodyClassName?: string;
  // Largura fixa (ex.: painel do ConLicitaSeg); sem ela, a de cada variante.
  width?: string;
  onClose: () => void;
  children: React.ReactNode;
}

const AiManagementDrawer: React.FC<AiManagementDrawerProps> = ({
  title,
  subtitle,
  variant = 'main',
  shifted = false,
  bodyClassName = 'px-4 py-4',
  width,
  onClose,
  children,
}) =>
  createPortal(
    <>
      {variant === 'main' ? <Backdrop onClick={onClose} /> : null}
      <Panel
        $variant={variant}
        $shifted={shifted}
        $width={width}
        className="d-flex flex-column bg-white"
      >
        <div className="drawer-header d-flex align-items-center justify-content-between border-bottom px-4 py-3">
          <div className="text-truncate mr-3">
            <h4 className="drawer-title font-weight-bold text-truncate mb-0">{title}</h4>
            {subtitle ? <div className="text-muted text-truncate">{subtitle}</div> : null}
          </div>
          <button
            type="button"
            className="btn btn-link text-dark p-0"
            onClick={onClose}
            aria-label="Fechar"
          >
            <i className="material-icons">close</i>
          </button>
        </div>
        <div className={`drawer-scroll overflow-auto ${bodyClassName}`}>{children}</div>
      </Panel>
    </>,
    document.body,
  );

export default AiManagementDrawer;
